import L from "leaflet";

L.Corridor = L.Polyline.extend({
  initialize: function (latlngs, options) {
    var self = this;

    L.Polyline.prototype.initialize.call(this, latlngs, options);

    this.corridor = options.corridor;
    this.updateCallback = function (e) {
      self._updateWeight(this);
    };
  },

  onAdd: function (map) {
    L.Polyline.prototype.onAdd.call(this, map);
    map.on("zoomend", this.updateCallback);
    map.on("baselayerchange", this.updateCallback);
    this._updateWeight(map);
  },

  onRemove: function (map) {
    map.off("zoomend", this.updateCallback);
    map.off("baselayerchange", this.updateCallback);
    L.Polyline.prototype.onRemove.call(this, map);
  },

  setStyle: function (style) {
    // Generic line styles use metre widths, whereas Leaflet's weight is in
    // pixels. Keep the corridor responsible for this conversion on restyles.
    const corridorStyle = this._map
      ? { ...style, weight: this._getWeight(this._map, this.corridor) }
      : style;
    return L.Polyline.prototype.setStyle.call(this, corridorStyle);
  },

  _updateWeight: function (map) {
    const weight = this._getWeight(map, this.corridor);
    this._deferredStyleUpdate(weight);
  },

  _deferredStyleUpdate: function (weight) {
    requestAnimationFrame(() => {
      this.setStyle({ weight });
    });
  },

  _getWeight: function (map, corridor) {
    return (corridor * 2) / this._getMetersPerPixel(map);
  },

  _getMetersPerPixel: function (map) {
    var centerLatLng = map.getCenter(); // get map center
    var pointC = map.latLngToContainerPoint(centerLatLng); // convert to containerpoint (pixels)
    var pointX = L.point(pointC.x + 10, pointC.y); // add 10 pixels to x

    // convert containerpoints to latlng's
    var latLngX = map.containerPointToLatLng(pointX);
    return centerLatLng.distanceTo(latLngX) / 10; // calculate distance between c and x (latitude)
  },
});

export default L.corridor = function (latlngs, options) {
  return new L.Corridor(latlngs, options || { corridor: 100 });
};
